export const fr = {
  translation: {
    post: "publication",
    remove_post: "Supprimer la publication",
    no_posts: "Aucune publication.",
    create_a_post: "Créer une publication",
    create_post: "Créer une publication",
    number_of_posts_0: "{{formattedCount}} publication",
    number_of_posts_1: "{{formattedCount}} publications",
    number_of_posts_2: "{{formattedCount}} publications",
    posts: "Publications",
    related_posts: "Ces publications sont similaires",
    cross_posts: "Ce lien a également été publié sur :",
    cross_post: "publication croisée",
    cross_posted_to: "publication croisée sur : ",
    comments: "Commentaires",
    number_of_comments_0: "{{formattedCount}} commentaire",
    number_of_comments_1: "{{formattedCount}} commentaires",
    number_of_comments_2: "{{formattedCount}} commentaires",
    remove_comment: "Supprimer le commentaire",
    communities: "Communautés",
    users: "Utilisateurs",
    create_a_community: "Créer une communauté",
    create_community: "Créer une communauté",
    remove_community: "Supprimer la Communauté",
    subscribed_to_communities: "Abonné à ces <1>communautés</1>",
    trending_communities: "<1>Communautés</1> appréciées",
    list_of_communities: "Liste des communautés",
    number_of_communities_0: "{{formattedCount}} communauté",
    number_of_communities_1: "{{formattedCount}} communautés",
    number_of_communities_2: "{{formattedCount}} communautés",
    community_reqs: "en minuscule, tirets du bas et sans espace.",
    create_private_message: "Créer un message privé",
    send_secure_message: "Envoyer un message sécurisé",
    send_message: "Envoyer le message",
    message: "Message",
    edit: "Éditer",
    reply: "Répondre",
    cancel: "Annuler",
    preview: "Prévisualiser",
    upload_image: "envoyer une image",
    avatar: "Avatar",
    upload_avatar: "Téléverser un avatar",
    show_avatars: "Afficher les avatars",
    formatting_help: "aide au formatage",
    view_source: "voir la source",
    unlock: "Déverrouiller",
    lock: "Verrouiller",
    sticky: "épingler",
    unsticky: "désépingler",
    link: "lien",
    archive_link: "archiver le lien",
    mod: "modérateur",
    mods: "modérateurs",
    moderates: "Modérer",
    settings: "Paramètres",
    remove_as_mod: "Supprimer comme modérateur",
    appoint_as_mod: "Nommer comme modérateur",
    modlog: "Journal de modération",
    admin: "admin",
    admins: "administrateurs",
    remove_as_admin: "Supprimer comme admin",
    appoint_as_admin: "Nommer comme administrateur",
    remove: "Retirer",
    removed: "Supprimé par le modérateur",
    locked: "Verrouillé",
    stickied: "épinglé",
    reason: "Raison",
    mark_as_read: "marquer comme lu",
    mark_as_unread: "marquer comme non-lu",
    delete: "Supprimer",
    deleted: "supprimé par le créateur",
    delete_account: "Supprimer le compte",
    delete_account_confirm: "Avertissement : cette action supprimera définitivement votre compte. Vos données pourraient ne pas être supprimées sur d'autres instances. Saisissez votre mot de passe pour confirmer.",
    restore: "Restaurer",
    ban: "Bannir",
    ban_from_site: "Bannir du site",
    unban: "Débannir",
    unban_from_site: "Débannir du site",
    banned: "Banni",
    save: "Sauvegarder",
    unsave: "Retirer",
    create: "créer",
    creator: "créateur",
    username: "Nom d’utilisateur·rice",
    email_or_username: "Email ou nom d’utilisateur·rice",
    number_of_users_0: "{{formattedCount}} utilisateur",
    number_of_users_1: "{{formattedCount}} utilisateurs",
    number_of_users_2: "{{formattedCount}} utilisateurs",
    number_of_subscribers_0: "{{formattedCount}} abonné·e",
    number_of_subscribers_1: "{{formattedCount}} abonné·e·s",
    number_of_subscribers_2: "{{formattedCount}} abonné·e·s",
    number_of_points_0: "{{formattedCount}} point",
    number_of_points_1: "{{formattedCount}} points",
    number_of_points_2: "{{formattedCount}} points",
    name: "Nom",
    title: "Titre",
    subscribers: "Abonnés",
    both: "Les deux",
    saved: "Sauvegardé",
    unsubscribe: "Se désabonner",
    subscribe: "S’abonner",
    subscribed: "Abonnés",
    prev: "Précédent",
    next: "Suivant",
    sidebar: "Panneau latéral",
    sort_type: "Trier",
    hot: "Tendances",
    new: "Nouveaux",
    old: "Ancien",
    month: "mois",
    all: "Tout",
    top: "Top",
    api: "API",
    docs: "Documentation",
    inbox: "Boîte de réception",
    inbox_for: "Boîte de réception de <1>{{user}}</1>",
    mark_all_as_read: "Tout marquer comme lu",
    type: "Type",
    unread: "Non-lu",
    replies: "Réponses",
    mentions: "Mentions",
    reply_sent: "Réponse envoyée",
    message_sent: "Message envoyé",
    search: "Rechercher",
    overview: "Général",
    view: "Voir",
    logout: "Déconnexion",
    login_sign_up: "Se connecter / S’inscrire",
    login: "Connexion",
    sign_up: "S’inscrire",
    notifications_error: "Les notifications de bureau ne sont pas disponibles sur votre navigateur. Essayez Firefox ou Chrome.",
    unread_messages_0: "{{formattedCount}} Message non lu",
    unread_messages_1: "{{formattedCount}} Messages non lus",
    unread_messages_2: "{{formattedCount}} Messages non lus",
    messages: "Messages",
    password: "Mot de passe",
    verify_password: "Vérifiez le mot de passe",
    old_password: "Ancien mot de passe",
    forgot_password: "Mot de passe oublié",
    reset_password_mail_sent: "Un email a été envoyé pour réinitialiser votre mot de passe.",
    password_change: "Changement de mot de passe",
    new_password: "Nouveau mot de passe",
    no_email_setup: "Ce serveur n’a pas correctement configuré la messagerie.",
    email: "Email",
    matrix_user_id: "Utilisateur Matrix",
    private_message_disclaimer: "Attention : les messages privés dans Lemmy ne sont pas chiffrés de bout en bout ; les administateurs des instances de l'expéditeur et du destinataire sont donc techniquement en mesure de les lire. Nous vous recommandons d'utiliser <1>Matrix</1> pour vos messages confidentiels.",
    send_notifications_to_email: "Envoyer des notifications par email",
    optional: "Optionnel",
    expires: "Expire",
    language_0: "Langue",
    language_1: "Langues",
    language_2: "Langues",
    downvotes_disabled: "Votes négatifs désactivés",
    enable_downvotes: "Votes négatifs activés",
    open_registration: "Ouvrir les inscriptions",
    registration_closed: "Inscriptions fermées",
    enable_nsfw: "Activer NSFW",
    url: "URL",
    body: "Texte",
    copy_suggested_title: "copier le titre suggéré : {{title}}",
    community: "Communauté",
    expand_here: "Agrandir ici",
    subscribe_to_communities: "S’abonner à quelques <1>communautés</1>.",
    chat: "Chat",
    recent_comments: "Commentaires récents",
    no_results: "Aucun résultats.",
    setup: "Installation",
    lemmy_instance_setup: "Installation d’une instance Lemmy",
    setup_admin: "Créer un administrateur",
    modified: "modifié",
    nsfw: "Pas sûr pour le travail (NSFW)",
    show_nsfw: "Afficher le contenu NSFW",
    theme: "Thème",
    code: "Code",
    joined: "Membre depuis",
    by: "par",
    to: "pour",
    from: "de",
    transfer_community: "Transférer la communauté",
    transfer_site: "Transférer le site",
    are_you_sure: "Êtes-vous sûr ?",
    yes: "Oui",
    no: "Non",
    not_logged_in: "Vous n’êtes pas connecté.",
    logged_in: "Vous êtes connecté.",
    community_ban: "Vous avez été banni de cette communauté.",
    site_ban: "Vous avez été banni du site",
    couldnt_create_comment: "Impossible de publier le commentaire.",
    couldnt_like_comment: "Impossible d’aimer le commentaire.",
    couldnt_update_comment: "Impossible de mettre à jour le commentaire.",
    couldnt_save_comment: "Impossible de sauvegarder le commentaire.",
    couldnt_get_comments: "Impossible d'obtenir les commentaires.",
    no_comment_edit_allowed: "Vous n’êtes pas autorisé à éditer ce commentaire.",
    no_post_edit_allowed: "Vous n’êtes pas autorisé à éditer cette publication.",
    no_community_edit_allowed: "Vous n’êtes pas autorisé à éditer cette communauté.",
    couldnt_find_community: "Impossible de trouver cette communauté.",
    couldnt_update_community: "Impossible de mettre à jour cette communauté.",
    community_already_exists: "Cette communauté existe déjà.",
    community_moderator_already_exists: "Ce membre est déjà modérateur.",
    community_follower_already_exists: "Ce membre est déjà abonné.",
    community_user_already_banned: "Ce membre est déjà banni.",
    couldnt_create_post: "Impossible de créer la publication.",
    couldnt_like_post: "Impossible d’aimer la publication.",
    couldnt_find_post: "Impossible de trouver la publication.",
    couldnt_get_posts: "Impossible d’obtenir les publications",
    couldnt_update_post: "Impossible de mettre à jour la publication",
    couldnt_save_post: "Impossible de sauvegarder la publication.",
    no_slurs: "Pas d’insultes.",
    not_an_admin: "Pas administrateur.",
    site_already_exists: "Le site existe déjà.",
    couldnt_update_site: "Impossible de mettre à jour le site.",
    couldnt_find_that_username_or_email: "Impossible de trouver cet·te utilisateur·rice ou cet email.",
    password_incorrect: "Mot de passe incorrect.",
    passwords_dont_match: "Les mots de passes ne correspondent pas.",
    admin_already_created: "Désolé, il y a déjà un admin.",
    user_already_exists: "L’utilisateur·rice existe déjà.",
    email_already_exists: "L’email existe déjà.",
    couldnt_update_user: "Impossible de mettre à jour l’utilisateur·rice.",
    system_err_login: "Erreur système. Essayez de vous déconnecter puis de vous reconnecter.",
    couldnt_create_private_message: "Impossible de créer un message privé.",
    no_private_message_edit_allowed: "Pas autorisé à modifier un message privé.",
    couldnt_update_private_message: "Impossible de modifier le message privé.",
    time: "Temps",
    action: "Action",
    more: "Plus",
    admin_settings: "Paramètres administrateur",
    site_config: "Configuration du site",
    banned_users: "Utilisateur·rice·s banni·e·s",
    site_saved: "Site sauvegardé.",
    sorting_help: "aide au tri",
    upvote: "Voter pour",
    show_context: "Afficher le contexte",
    block_leaving: "Êtes-vous sûr de vouloir partir ?",
    number_of_upvotes_0: "{{formattedCount}} vote pour",
    number_of_upvotes_1: "{{formattedCount}} votes pour",
    number_of_upvotes_2: "{{formattedCount}} votes pour",
    number_of_downvotes_0: "{{formattedCount}} vote contre",
    number_of_downvotes_1: "{{formattedCount}} votes contre",
    number_of_downvotes_2: "{{formattedCount}} votes contre",
    downvote: "Voter contre",
    emoji_picker: "Sélecteur d’émojis",
    select_a_community: "Sélectionner une communauté",
    invalid_username: "Nom d'utilisateur invalide.",
    invalid_community_name: "Nom invalide.",
    click_to_delete_picture: "Cliquez pour supprimer l'image : {{filename}}",
    picture_deleted: "Image supprimée : {{filename}}",
    invalid_post_title: "Titre du post invalide",
    must_login: "Vous devez vous être <1>connecté</1> ou <2>enregistré</2> pour commenter.",
    no_password_reset: "Vous ne pourrez pas réinitialiser votre mot de passe sans un e-mail.",
    what_is: "Combien font",
    cake_day_title: "Lemmyversaire :",
    invalid_url: "URL invalide.",
    name_explain: "Nom – utilisé comme identifiant par la communauté, ne peut être changé.",
    display_name_explain: "Nom affiché – montré comme titre sur la page de la communauté, peut être changé.",
    invalid_password: "La longueur du mot de passe doit être entre 10 et 60 caractères.",
    bio_length_overflow: "La bio utilisateur ne peut dépasser 1000 caractères.",
    display_name: "Nom affiché",
    not_a_moderator: "Pas un modérateur.",
    enter_code: "Entrez le code",
    captcha_incorrect: "Captcha erroné.",
    subscript: "indice",
    superscript: "exposant",
    bold: "gras",
    italic: "italique",
    header: "en-tête",
    strikethrough: "barré",
    quote: "citation",
    spoiler: "divulgâche",
    list: "liste",
    local: "Local",
    play_captcha_audio: "Jouer le captcha audio",
    bio: "Bio",
    none_found: "Pas trouvé.",
    linked_instances: "Instances liées",
    instances: "Instances",
    banner: "Bannière",
    upload_banner: "Téléverser une bannière",
    icon: "Icône",
    upload_icon: "Partager une icône",
    leave_mod_team: "Quitter l’équipe de modération",
    active: "Actif",
    cake_day_info: "Aujourd’hui c’est le gâteau jour de {{ creator_name }} !",
    parent_comment_not_in_post: "Le commentaire parent appartient à un autre poste.",
    captcha: "Captcha",
    most_comments: "Plus commentés",
    day: "jour",
    week: "semaine",
    number_of_months_0: "{{formattedCount}} mois",
    number_of_months_1: "{{formattedCount}} mois",
    number_of_months_2: "{{formattedCount}} mois",
    couldnt_find_parent_comment: "Impossible de trouver le commentaire parent.",
    allowed_instances: "Instances autorisées",
    new_comments: "Nouveaux commentaires",
    blocked_instances: "Instances bloquées",
    expand: "Agrandir",
    collapse: "Minimiser",
    join_lemmy: "Rejoindre Lemmy",
    support_lemmy: "Soutenir Lemmy",
    report_reason_required: "Raison du signalement requise.",
    couldnt_create_report: "Impossible de créer le signalement.",
    couldnt_resolve_report: "Impossible de résoudre le rapport.",
    report_too_long: "Rapport trop long.",
    not_a_mod_or_admin: "Pas un modérateur ou un administrateur.",
    invalid_matrix_id: "Identifiant Matrix invalide. Doit être @user:instance.tld",
    site_description_length_overflow: "Description du site ne peut excéder 150 caractères.",
    blocked_communities: "Les communautés bloquées",
    local_description: "Affichez uniquement les communautés",
    bot_account: "Compte robot",
    change_password: "Modifier le mot de passe",
    blocked_users: "Utilisateur·rice·s bloqué·e·s",
    block_user: "Bloquer l’utilisateur",
    block_community: "Bloquer la communauté",
    person_block: "Cet·te utilisateur·rice vous a bloqué.",
    explore_communities: "Explorer les communautés",
    comment_here: "Saisissez votre commentaire ici …",
    only_admins_can_create_communities: "Les administrateurs seuls peuvent créer des communautés",
    description: "Description",
    community_creation_admin_only: "Seul les admins peuvent créer des communautés",
    remove_content: "Supprimer le contenu",
    remove_content_more: "Supprimer les publications, commentaires et communautés",
    profile: "Profil",
    very_weak: "Très faible",
    show_scores: "Afficher les scores",
    cannot_leave_admin: "Vous ne pouvez pas laisser le serveur sans administrateur",
    weak: "Faible",
    medium: "Moyen",
    subscribed_description: "Affiche les communautés auxquelles vous êtes abonné",
    websocket_disconnected: "Websocket déconnecté",
    websocket_reconnected: "Websocket reconnecté",
    password_changed: "Mot de passe changé.",
    unblocked: "Débloqué",
    unblock_user: "Débloquer l'utilisateur",
    unblock_community: "Débloquer la communauté",
    blocks: "Blocages",
    resolved_by: "Résolu par <1></1>",
    unread_reports_0: "{{formattedCount}} Signalement non lu",
    unread_reports_1: "{{formattedCount}} Signalements non lus",
    unread_reports_2: "{{formattedCount}} Signalements non lus",
    active_users_in_the_last_day_0: "{{formattedCount}} utilisateur actif au cours du dernier jour",
    active_users_in_the_last_day_1: "{{formattedCount}} utilisateurs actifs au cours du dernier jour",
    active_users_in_the_last_day_2: "{{formattedCount}} utilisateurs actifs au cours du dernier jour",
    active_users_in_the_last_month_0: "{{formattedCount}} utilisateur actif au cours du dernier mois",
    active_users_in_the_last_month_1: "{{formattedCount}} utilisateurs actifs au cours du dernier mois",
    active_users_in_the_last_month_2: "{{formattedCount}} utilisateurs actifs au cours du dernier mois",
    active_users_in_the_last_six_months_0: "{{formattedCount}} utilisateur actif au cours des 6 derniers mois",
    active_users_in_the_last_six_months_1: "{{formattedCount}} utilisateurs actifs au cours des 6 derniers mois",
    active_users_in_the_last_six_months_2: "{{formattedCount}} utilisateurs actifs au cours des 6 derniers mois",
    number_of_days: "Nombre de jours",
    trending: "Tendances",
    show_bot_accounts: "Afficher les comptes robots",
    show_read_posts: "Afficher les publications lues",
    leave_admin_team: "Quitter l'équipe d'administrateurs",
    left_admin_team: "Vous avez quitté l'équipe d'administrateur",
    strong: "Fort",
    active_users_in_the_last_week_0: "{{formattedCount}} utilisateur actif au cours de la dernière semaine",
    active_users_in_the_last_week_1: "{{formattedCount}} utilisateurs actifs au cours de la dernière semaine",
    active_users_in_the_last_week_2: "{{formattedCount}} utilisateurs actifs au cours de la dernière semaine",
    created: "créé",
    blocked: "Bloqué",
    reports: "Signalements",
    instance_is_private: "Cette instance est privée.",
    email_required: "Email requis.",
    email_verified: "Votre adresse email a été vérifiée.",
    email_not_verified: "Email non vérifié.",
    verify_email_sent: "Email de vérification envoyé.",
    answer: "Réponse",
    registration_application_answer_required: "Inscription requise.",
    default_theme: "Thème par défaut",
    approve: "Approuver",
    approved_by: "Approuvé par <1></1>",
    private_instance: "Instance privée",
    couldnt_find_comment: "Commentaire non trouvé.",
    resolve_report: "Résoudre le rapport",
    create_report: "Créer un signalement",
    report_created: "Le signalement a été créé.",
    registration_applications: "Demandes d’inscription",
    deny_reason: "Raison du refus",
    denied_by: "Refusée par <1></1>",
    deny: "Refuser",
    required: "Requis",
    registration_application_sent: "La demande d’inscription a été envoyée.",
    apply_to_join: "Demander à rejoindre",
    ban_from_community: "Bannir de la communauté",
    loading: "Chargement",
    profile_not_logged_in_alert: "Vous n'êtes pas connecté·e. Si vous utilisez un compte du Fédivers qui peut suivre des comptes, vous pouvez suivre cette personne.",
    community_not_logged_in_alert: "Vous n'êtes pas connecté·e. Vous pouvez suivre cette communauté depuis un autre compte du fédivers, comme Lemmy ou Mastodon. Pour ce faire, copiez <1>!{{community}}@{{instance}}</1> et collez le texte dans la barre de recherche de votre instance",
    filter_by_action: "Filtrer par action",
    filter_by_mod: "Filtrer par modérateur·ice",
    filter_by_user: "Filtrer par utilisateur·ice",
    too_many_images_upload_0: "Le maximum de {{formattedCount}} image a été dépassé. Ne sélectionnez qu'une seule image.",
    too_many_images_upload_1: "Le maximum de {{formattedCount}} images a été dépassé. Sélectionnez moins d'images.",
    too_many_images_upload_2: "Le maximum de {{formattedCount}} images a été dépassé. Sélectionnez moins d'images.",
    view_all_comments: "Voir tous les commentaires",
    only_mods_can_post_in_community: "Seules les personnes avec les droits de modération peuvent publier dans cette communauté",
    failed_to_delete_picture: "Nous n'avons pas pu supprimer l'image : {{filename}}",
    purge: "Purger",
    purge_post: "Purger la publication",
    purge_comment: "Purger le commentaire",
    purge_community: "Purger la communauté",
    purge_user: "Purger l'utilisateur·ice",
    jump_to_content: "Aller au contenu",
    undetermined_language_warning: "Avertissement : Si vous désélectionnez l'option indéterminé, vous ne verrez pas la plupart des contenus.",
    subscribe_pending: "Abonnement en attente",
    error_page_admin_matrix: "Si vous souhaitez contacter l'un des administrateurs de {{instance}} pour obtenir de l'aide, essayez les adresses Matrix suivantes :",
    not_found_page_message: "La page que vous recherchez n'existe pas.",
    not_found_return_home_button: "Cliquez ici pour revenir à votre page d'accueil",
    language_select_placeholder: "Choisir la langue",
    verify_email: "Vérifier l'adresse électronique",
    registration_mode: "Mode d'inscription",
    close_registration: "Fermer l'inscription",
    error_page_title: "Erreur !",
    not_found_page_title: "Page introuvable",
    listing_type: "Type de liste",
    couldnt_mark_post_as_read: "Impossible de marquer le message comme lu.",
    rate_limit_error: "Trop de demandes, réessayez plus tard.",
    modlog_content_warning: "<1>AVERTISSEMENT SUR LE CONTENU</1> : Certains messages supprimés peuvent contenir du matériel dérangeant ou destiné aux adultes. Procédez avec prudence.",
    x_more_replies_0: "{{formattedCount}} réponse de plus",
    x_more_replies_1: "{{formattedCount}} réponses de plus",
    x_more_replies_2: "{{formattedCount}} réponses de plus",
    error_page_paragraph: "Une erreur s'est produite sur le serveur. Essayez d'actualiser votre navigateur. Si cela ne fonctionne pas, revenez plus tard. Si le problème persiste, vous pouvez demander de l'aide à la <1>Communauté d'assistance Lemmy</1> ou à la <1>Groupe Matrix Lemmy</1>.",
    error_code_message: "Le serveur a renvoyé cette erreur : <1>{{error}}</1>. Cela peut être utile aux administrateur·rice·s et aux développeur·rice·s pour diagnostiquer et corriger l'erreur",
    unread_registration_applications_0: "{{formattedCount}} Demande non lue",
    unread_registration_applications_1: "{{formattedCount}} Demandes non lues",
    unread_registration_applications_2: "{{formattedCount}} Demandes non lues",
    fill_out_application: "Pour rejoindre ce serveur, vous devez remplir ce formulaire et attendre d'être accepté·e.",
    require_email_verification: "Exiger une vérification de l'adresse électronique",
    distinguish: "Parler en tant que modérateur",
    undistinguish: "Parler en tant qu'utilisateur",
    purge_warning: "Attention : La purge supprimera cet élément et tous ses sous-éléments de la base de données. Vous ne pourrez pas récupérer les données. À utiliser avec une extrême prudence.",
    purge_success: "L'élément a été purgé avec succès.",
    all_description: "Affiche toutes les communautés, y compris les communautés fédérées",
    interface_language: "Langue de l'interface",
    unresolved_by: "Non résolu par <1></1>",
    show_report_dialog: "Afficher la boîte de dialogue du rapport",
    require_registration_application: "Exiger une demande d'enregistrement",
    application_email_admins: "Envoi d'un courrier électronique aux administrateurs lors de la réception de nouvelles demandes",
    show_password: "Afficher le mot de passe",
    hide_password: "Cacher le mot de passe",
    version: "Version",
    cant_enable_private_instance_and_federation_together: "Impossible d'activer l'instance privée et la fédération en même temps",
    unfeature_from_local: "Retirer la promotion en local",
    column_imageurl: "URL de l'image",
    upload_too_large: "L'image téléversée est trop grande !",
    moderator_view: "Vue modérateur",
    moderator_view_description: "Voir seulement les contributions des communautés dont vous êtes modérateur",
    rate_limit_message: "Message",
    unfeature_from_community: "Retirer la promotion sur la communauté",
    deleted_emoji: "Émoji supprimé",
    application_questionnaire: "Questionnaire d'adhésion",
    reports_email_admins: "Envoyer un courriel aux administrateurs lors de la réception de signalements",
    hide_modlog_mod_names: "Cacher les noms des modérateurs dans le modlog",
    rate_limit: "Limite de taux",
    rate_limit_header: "Options de limitation de taux",
    site_name_required: "Nom du site requis.",
    site_name_length_overflow: "Le nom du site ne peut pas excéder 20 caractères",
    reset_password: "Réinitialiser le mot de passe",
    unresolve_report: "Annuler la résolution du signalement",
    application_email_reason_none: "Adhésion refusée",
    legal_information: "Légal",
    slur_filter_regex: "Regex de filtrage de mots choquants",
    invalid_regex: "Expression régulière invalide.",
    permissive_regex: "L'expression régulière correspondrait à n'importe-quel texte.",
    actor_name_max_length: "Longueur maximale pour le nom de l'intervenant",
    federation_http_fetch_retry_limit: "Limite de tentatives de requêtes HTTP sur les instances fédérées",
    easy: "Facile",
    hard: "Difficile",
    rate_limit_post: "Publication",
    rate_limit_register: "Inscription",
    rate_limit_image: "Image",
    rate_limit_comment: "Commentaire",
    rate_limit_search: "Recherche",
    per_second: "Par seconde",
    taglines: "Étiquettes",
    add_tagline: "Ajouter une étiquette",
    featured: "Promu",
    featured_in_local: "Promu en local",
    featured_in_community: "Promu dans la communauté",
    feature_in_local: "Promouvoir en local",
    feature_in_community: "Promouvoir sur la communauté",
    saved_emoji: "Émoji sauvegardé",
    custom_emoji_save_validation: "Tous les champs doivent être remplis et le code raccourci ne peut être dupliqué.",
    add_custom_emoji: "Ajouter un émoji personalisé",
    column_keywords: "Mots-clés (séparés par un espace)",
    column_alttext: "Texte alternatif",
    column_shortcode: "Code raccourci",
    column_category: "Catégorie",
    column_emoji: "Émoji",
    custom_emojis: "Émojis personalisés",
    emojis: "Émojis",
    emoji: "Émoji",
    site: "Site",
    software: "Logiciel",
    remove_instance: "Supprimer l'instance",
    add_instance: "Ajouter une instance",
    open_links_in_new_tab: "Ouvrir les liens dans un nouvel onglet",
    op: "OP",
    couldnt_create_audio_captcha: "Échec de la création d'un Captcha audio.",
    incorrect_login: "Identifiants de connexion invalide",
    federation_enabled: "Fédération activée",
    federation_debug: "Mode débogage de fédération",
    federation_strict_allowlist: "Liste d'autorisation stricte pour les instances fédérées",
    federation_worker_count: "Nombre de travailleurs pour la fédération",
    reporter: "Personne ayant signalée",
    registration_denied: "Demande d'inscription refusée.",
    registration_application_pending: "Approbation d'inscription en attente.",
    applicant: "Candidat",
    remote_follow_prompt: "Entrez l'instance depuis laquelle vous désirez suivre cette communauté",
    fetch_community: "Récupérer la communauté",
    could_not_fetch_community: "Impossible de récupérer {{community}}",
    remote_follow: "Suivre depuis instance distante",
    controversial: "Controversé",
    community_federated: "Communauté fédérée !",
    fetching_community: "Récupération de {{community}}",
    remote_follow_modal_title: "S'abonner depuis l'instance distante",
    blur_nsfw: "Flouter le contenu NSFW",
    pictures_uploaded_progess: "{{uploaded}}/{{total}} images téléversées",
    scaled: "Mis à l'échelle",
    invalid_totp_code: "Code 2FA invalide : doit être 6 chiffres",
    incorrect_totp_code: "Code 2FA incorrect",
    enable_totp: "Activer l'authentification à deux facteurs",
    enter_totp_code: "Entrez votre code 2FA",
    totp_link: "Cliquez ici pour le lien d'installation 2FA",
    disable_totp: "Désactiver l'authentification à deux facteurs",
    totp_qr: "Code QR pour l'authentification à deux facteurs",
    totp_qr_segue: "ou scannez ce code QR dans une application authenticateur",
    enable_totp_success: "Authentification à deux facteurs activée avec succès",
    disable_totp_success: "Authentification à deux facteurs désactivée avec succès",
    remote_follow_invalid_instance: "{{instance}} n'est pas un nom de domaine valide.",
    remote_follow_local_instance: "Impossible de récupérer les suivis de l'instance distante depuis l'instance locale",
    block_instance: "Bloquer l'instance",
    unblock_instance: "Débloquer l'instance",
    import_export_section_title: "Importer/Exporter les paramètres",
    import_export_section_description: "Importer et exporter les paramètres de compte en JSON",
    export: "Exporter",
    import: "Importer",
    exporting: "Exportation",
    importing: "Importation",
    import_export_rate_limit_error: "Veuillez attendre quelques minutes avant de réessayer d'importer ou d'exporter les paramètres une nouvelle fois",
    export_error: "Erreur lors de l'exportation des paramètres",
    import_error: "Erreur lors de l'importation des paramètres",
    export_file_name: "lemmy_user_settings",
    import_success: "Paramètres importés avec succès !",
    removed_post: "Publication supprimée",
    restore_post: "Restaurer la publication",
    restored_post: "Publication restaurée",
    removed_comment: "Commentaire retiré",
    restore_comment: "Restaurer le commentaire",
    restored_comment: "Commentaire restauré",
    distinguished_comment: "Commentaire distingué",
    remove_as_mod_are_you_sure: "Êtes-vous certain de vouloir retirer {{user}} comme modérateur de {{community}} ?",
    removed_mod: "Modérateur retiré",
    submit: "Envoyer",
    view_votes: "Voir les votes",
    votes: "Votes",
    community_locked_message: "<1>Verrouillé pour la communauté:</1> seuls les modérateurs peuvent publier. Vous pouvez toujours commenter les publications.",
    community_locked: "Verrouillé pour la communauté",
    confirmation_required: "Confirmation requise",
    transferring_community: "Transfert de la communauté",
    featured_post: "Publication promue",
    denied: "Refusé",
    removing_mod: "Suppression du modérateur",
    appointing_mod: "Désignation du modérateur",
    appointed_mod: "Nommé modérateur",
    remove_as_admin_are_you_sure: "Êtes-vous sûr de vouloir retirer {{user}} de l'équipe d'administrateurs de {{instance}} ?",
    appoint_as_mod_are_you_sure: "Êtes-vous sûr de vouloir nommer {{user}} comme modérateur de {{community}} ?",
    removed_admin: "Administrateur supprimé",
    appointing_admin: "Désignation l'administrateur",
    appointed_admin: "Désigné comme administrateur",
    removing_admin: "Suppression de l'administrateur",
    appoint_as_admin_are_you_sure: "Êtes-vous sûr de vouloir nommer {{user}} administrateur de {{instance}} ?",
    removing: "Suppression",
    unlocked: "Déverrouillé",
    locked_post: "Publication verrouillée",
    unlocked_post: "Publication déverrouillée",
    deleted_post: "Publication supprimée",
    deleted_comment: "Commentaire supprimé",
    restoring: "Restauration",
    permanently_ban: "Bannir définitivement",
    ban_with_name: "Bannir {{user }}",
    banning: "Bannissement de {{user}}",
    ban_from_community_with_name: "Bannir {{user}} de {{community}}",
    undelete: "Annuler la suppression",
    unban_with_name: "Débannir {{user}}",
    unbanning: "Débannissement de {{user}}",
    unban_from_community: "Débannir de la communauté",
    unban_from_community_with_name: "Débannir {{user}} de {{community}}",
    banned_from_community: "{{user}} banni de {{community}}",
    unbanned_from_community: "{{user}} débanni de {{community}}",
    banned_from_site: "{{user}} banni",
    unbanned_from_site: "{{user}} débanni",
    purging: "Purge en cours",
    days_until_expiration: "Jours avant expiration",
    transfer_community_are_you_sure: "Êtes-vous sûr de vouloir transférer {{community}} à {{user}} ?",
    transfered_community: "Communauté transférée",
    creating_report: "Création du signalement",
    report_post: "Signaler la publication",
    report_comment: "Signaler le commentaire",
    report_message: "Signaler le message",
    purge_user_with_name: "Purger {{user}}",
    undistinguished_comment: "Commentaire non distingué",
    undeleted_comment: "Commentaire restauré",
    undeleted_post: "Publication restaurée",
    unfeatured_post: "Publication non promue",
    public_blurb: "Cette communauté peut être fédérée vers d'autres instances et leurs utilisateurs peuvent publier/commenter.",
    banned_from_community_blurb: "<1>Banni:<1> Vous ne pouvez pas publier, commenter ou voter dans cette communauté. Vous pouvez toutefois continuer de naviguer librement.",
    delete_account_content: "Supprimer les publications, commentaires et images téléversées",
    custom_thumbnail_url: "URL de la miniature",
    number_of_local_subscribers_0: "{{formattedCount}} abonné·e local",
    number_of_local_subscribers_1: "{{formattedCount}} abonné·e·s locaux",
    number_of_local_subscribers_2: "{{formattedCount}} abonné·e·s locaux",
    community_visibility: "Visibilité",
    private_message_form_user_matrix_blurb: "Cet utilisateur possède déjà un compte Matrix lequel vous pouvez envoyer un message à l'adresse <1>{{matrix_id}}</1>.",
    post_unhidden: "Publication décachée",
    hide_post: "Cacher la publication",
    unhide_post: "Décacher la publication",
    show_hidden_posts: "Afficher les publications cachées",
    post_hidden: "Publication cachée",
    block_urls: "Bloquer des URLs",
    block_urls_placeholder: "Entrez la liste des URLs bloquées, une URL par ligne. Les expressions régulières sont supportées, par exemple: «*.example.com»",
    hide_hidden_posts: "Ne pas afficher les publications cachées",
    edited_post: "Publication modifiée",
    language_not_allowed: "Langue non permise",
    go_back: "Revenir en arrière",
    content_warning: "Avertissement de contenu",
    sending_back_message: "Compris 👍. Nous vous renvoyons dans {{seconds}}.",
    continue: "Continuer",
    content_warning_setting_blurb: "Configurer un avertissement de contenu affichera un avertissement de contenu demandant le consentement de l'utilisateur avant de continuer.",
    show_upvotes: "Afficher les votes pour",
    show_downvotes: "Afficher les votes contre",
    show_upvote_percentage: "Afficher le % de votes pour",
    upvote_percentage: "{{formattedCount}}% ont voté pour",
    uploads: "Téléversements",
    uploader: "Téléversé par",
    auto_expand: "Développer automatiquement les médias",
    add: "Ajouter",
    post_sort_type: "Type de tri des publications",
    comment_sort_type: "Type de tri des commentaires",
    username_already_exists: "Le nom d'utilisateur existe déjà.",
    authentication: "Authentification",
    oauth_config: "Configuration OAuth",
    oauth_providers: "Fournisseurs",
    add_oauth_provider: "Ajouter un fournisseur",
    oauth_provider_presets: "Fournisseurs préconfigurés",
    no_oauth_providers_blurb: "Aucun fournisseur",
    delete_oauth_provider_are_you_sure: "Êtes-vous certain de vouloir supprimer ce fournisseur ?",
    deleting_oauth_provider: "Suppression du fournisseur...",
    oauth_display_name: "Nom d'affichage",
    warning_sent: "Avertissement envoyé",
    purge_community_with_name: "Purger {{community}}",
    one_hour: "Une heure",
    n_seconds_0: "{{formattedCount}} seconde",
    n_seconds_1: "{{formattedCount}} secondes",
    n_seconds_2: "{{formattedCount}} secondes",
    n_months_0: "{{formattedCount}} mois",
    n_months_1: "{{formattedCount}} mois",
    n_months_2: "{{formattedCount}} mois",
    all_creators: "Tous les créateurs",
    months: "Mois",
    stay_logged_in: "Rester connecté",
    couldnt_delete_custom_emoji: "Impossible de supprimer l'emoji personnalisé",
    community_visibility_public_desc: "Cette communauté est visible par tout le monde.",
    community_visibility_private_desc: "Cette communauté est privée et n'est accessible qu'aux utilisateurs ayant été manuellement approuvés par les modérateurs.",
    rate_limit_import_user_settings: "Importer les paramètres",
    all_communities: "Toutes les communautés",
    all_users: "Tous les utilisateurs",
    show_unresolved_only: "Afficher uniquement les non-résolus",
    resend_verification_email: "Renvoyer l'email de vérification",
    tagline_updated: "Étiquette mise à jour",
    tagline_deleted: "Étiquette supprimée",
    tagline_created: "Étiquette créée",
    couldnt_create_tagline: "Impossible de créer une étiquette",
    couldnt_update_tagline: "Impossible de mettre à jour l'étiquette",
    couldnt_delete_tagline: "Impossible de supprimer l'étiquette",
    leave_admin_team_confirmation: "Êtes-vous sûr de vouloir quitter l'équipe d'administration ?",
    leave_mod_team_confirmation: "Êtes-vous sûr de vouloir quitter l'équipe de modération ?",
    lock_post: "Verouiller la publication",
    unlock_post: "Déverouiller la publication",
    cross_posted_from_url: "cross-posté de : {{ap_id}}",
    private_blurb: "Seuls les utilisateurs approuvés peuvent interagir avec cette communauté.",
    locking: "Verouillage",
    share_post: "Partager la publication",
    lock_comment: "Verouiller le commentaire",
    unlock_comment: "Déverouiller le commentaire",
    restored_community: "Communauté restaurée",
    days: "Jours",
    warn_user: "Avertir l'utilisateur",
    restore_community: "Restaurer la communauté",
    add_community: "Ajouter une communauté",
    hide_read_posts: "Cacher les publications lues",
    card: "Carte",
    small_card: "Petite carte",
    all_mods: "Tous les modérateurs",
    left_mod_team: "Vous avez quitté l'équipe de modération",
    removing_posts: "Suppression des publications",
    locking_posts: "Verouillage des publications",
    locking_comments: "Verouillage des commentaires",
    featuring_posts_for_local_instance: "Publications à la une pour l'instance locale",
    removing_comments: "Suppression des commentaires",
    removing_communities: "Suppression des communautés",
    banning_from_site: "Exclusion du site",
    banning_from_communities: "Exclusion des communautés",
    adding_mod_to_community: "Ajout du modérateur à la communauté",
    transferring_communities: "Transfert des communautés",
    adding_admin_to_site: "Ajout de l'administateur au site",
    blocking_a_federated_instance: "Blocage d'une instance fédérée",
    allowing_a_federated_instance: "Autorisation d'une instance fédérée",
    unlocking: "Déverouillage",
    deleted_community: "Communauté supprimée",
    banned_from_community_badge: "Banni de la communauté",
    show_sidebar: "Afficher le panneau latéral",
    sort: "Trier",
    six_hours: "Six heures",
    twelve_hours: "Douze heures",
    one_day: "Un jour",
    one_week: "Une semaine",
    one_month: "Un mois",
    three_months: "Trois mois",
    six_months: "Six mois",
    nine_months: "Neuf mois",
    one_year: "Un an",
    seconds: "Secondes",
    minutes: "Minutes",
    hours: "Heures",
    weeks: "Semaines",
    years: "Ans",
    n_hours_0: "{{formattedCount}} heure",
    n_hours_1: "{{formattedCount}} heures",
    n_hours_2: "{{formattedCount}} heures",
    n_days_0: "{{formattedCount}} jour",
    n_days_1: "{{formattedCount}} jours",
    n_days_2: "{{formattedCount}} jours",
    n_weeks_0: "{{formattedCount}} semaine",
    n_weeks_1: "{{formattedCount}} semaines",
    n_weeks_2: "{{formattedCount}} semaines",
    time_unit: "Unité de temps",
    read: "Lu",
    show_unread_only: "Afficher uniquement les non-lus",
    upvoted: "Upvoté",
    notifications: "Notifications",
    language_browser_default: "Paramètres par défaut du navigateur",
    theme_instance_default: "Paramètres par défaut de l'instance",
    allow_instance: "Autoriser l'instance",
    report_community: "Signaler la communauté",
    disable_email_notifications: "Désactiver les notifications par email",
    custom_emoji_updated: "Émoji personalisé mis à jour",
    custom_emoji_deleted: "Émoji personalisé supprimé",
    custom_emoji_created: "Émoji personalisé créé",
    couldnt_create_custom_emoji: "Impossible de créer un emoji personnalisé",
    couldnt_update_custom_emoji: "Impossible de mettre à jour l'emoji personnalisé",
    community_added: "Communauté ajoutée",
    domain: "Domaine",
    community_visibility_private: "Privée",
    show_content: "Afficher le contenu",
    post_time_range: "Afficher les publications les plus récentes",
    edit_as_mod: "Éditer en tant que modérateur",
    appoint_mod: "Nommer un modérateur",
    featuring_posts_in_community: "Publications à la une dans la communauté",
    changing_community_visibility: "Modification de la visibilité de la communauté",
    purging_a_person: "Purge d'une personne en cours",
    purging_a_community: "Purge d'une communauté en cours",
    purging_a_post: "Purge d'une publication en cours",
    purging_a_comment: "Purge d'un commentaire en cours",
    locked_post_comment_placeholder: "Ce contenu est verouillé, vous ne pouvez pas commenter.",
    n_years_0: "{{formattedCount}} an",
    n_years_1: "{{formattedCount}} ans",
    n_years_2: "{{formattedCount}} ans",
    time_interval: "Intervalle de temps",
    setup_your_site: "Configurer votre site",
    edit_your_site: "Modifier votre site",
    donation_dialog_message: "Un projet open source de l'envergure de Lemmy nécessite un travail constant pour assurer sa gestion, mettre en place de nouvelles fonctionnalités et corriger les bugs. Dessalines et Nutomic se consacrent à plein temps à ces tâches et d'autres. Comme il n'y a ni publicité ni traçage, l'ensemble de notre travail est financé par des dons. Malgré cela, les journées sont à peine suffisantes, et il ne reste pas de temps pour exercer un deuxième emploi. La seule option disponible est celle des dons des utilisateurs. Pour assurer la viabilité du projet, les dons doivent atteindre un minimum de 5 000 € par mois, ce qui permettrait de verser un salaire modeste de 2 500 € par développeur. Si cet objectif est atteint, nous pourrons cesser de nous soucier de l'argent et nous concentrer pleinement sur l'amélioration du logiciel au bénéfice de tous les utilisateurs et de toutes les instances. Nous comptons tout particulièrement sur les dons récurrents pour assurer le développement à long terme et faire de Lemmy le meilleur projet possible.<br/><br/>Si vous souhaitez obtenir plus d'informations avant de faire un don, pensez à la comparaison avec Reddit. À ses débuts, c'était une start-up financée par de riches investisseurs. Le site est géré par des dirigeants d'entreprise qui, au fil du temps, se sont de plus en plus déconnectés des utilisateurs lambda. Leur objectif principal est de satisfaire les investisseurs et de générer des profits. Cela conduit à des décisions hostiles envers les utilisateurs, comme le licenciement de l'employé chargé des AMA, le blocage d'applications tierces, et bien d'autres encore. Comme Reddit est un site web unique placé sous une seule autorité, cela signifie que tous les utilisateurs doivent suivre les mêmes règles, y compris des règles absurdes comme la censure du nom « Luigi ».<br/><br/>Lemmy représente un nouveau type de réseau social qui est l’exact opposé de Reddit. Il est réparti sur de nombreux sites web différents, chacun avec ses propres règles, et géré par des gens ordinaires qui se soucient réellement des utilisateurs. Il n’y a ni entreprise ni but lucratif. Une grande partie du travail est effectuée par des administrateurs, des modérateurs et des contributeurs bénévoles, qui s’investissent par enthousiasme et non pour l’argent. Pour les utilisateurs, c'est formidable car il n'y a ni publicité ni traçage, et aucun risque de rachat par un milliardaire. De plus, il n'y a aucune restriction politique ou idéologique intégrée. Vous pouvez utiliser le logiciel comme bon vous semble, ajouter vos propres restrictions ou examiner son fonctionnement interne. Lemmy appartient véritablement à tout le monde.<br/><br/>Nutomic et Dessalines, développeurs de Lemmy",
    notifications_updated: "Notifications mises à jour",
    banned_dialog_title_temporary: "Vous avez été temporairement banni (expiration le {{expires}})",
    banned_dialog_body: "Vous ne pouvez pas publier, voter ni effectuer d'autres actions. Vous pouvez toutefois continuer à naviguer sur le site et, depuis la page des paramètres, exporter vos paramètres pour les importer sur une autre instance de Lemmy, créer une sauvegarde ou supprimer votre compte.",
    person_is_banned_from_community: "Vous êtes banni·e de cette communauté",
    not_higher_mod: "Impossible d'apporter des modifications à un modérateur de rang supérieur",
    not_higher_admin: "Impossible d'apporter des modifications à un administrateur de rang supérieur",
    edit_private_message_not_allowed: "Vous n'êtes pas autorisé·e à modifier ce message privé",
    too_many_scheduled_posts: "Vous ne pouvez pas avoir plus de 10 publications programmées actives à la fois",
    missing_alt_text: "Pensez à rédiger une brève description (texte alternatif) pour cette image ou pour ce fichier multimédia afin d'aider les lecteurs malvoyants.",
    slurs: "Le texte contient une insulte qui est bloquée par cette instance",
    contradicting_filters: "Il n'est pas possible d'utiliser les filtres « Aimés uniquement » et « Pas aimés uniquement » ensemble",
    hidden: "Caché",
    torrent_help: "Lemmy peut utiliser une technologie appelée BitTorrent pour visionner ou diffuser des fichiers multimédias. <1>Cliquez ici</1> pour savoir comment faire.",
    registration_for_user: "Inscription pour {{name}}",
    loading_registration: "Chargement de l'inscription",
    fetch_registration_error: "Impossible de récupérer la demande d'inscription",
    view_registration: "Voir l'inscription",
    post_title_only: "Titre de la publication uniquement",
    post_url_only: "URL de la publication uniquement",
    donation_dialog_title: "Contribuer au développement de Lemmy",
    donation_dialog_button_hide: "Cacher",
    disable: "Désactiver",
    removed_item_from_list: "{{item}} retiré de {{list}}",
    added_item_to_list: "{{item}} ajouté à {{list}}",
    upload: "Téléverser",
    note_created: "Note créée",
    private: "Privé",
    too_many_items: "Trop d'éléments",
    oauth_issuer: "Émetteur",
    donation_dialog_button_donate: "Faire un don",
    mark_page_as_read: "Marquer la page comme lue",
    image_uploaded: "Image téléversée",
    image_deleted: "Image supprimée",
    subscribers_local: "Abonnés locaux",
    active_weekly: "Actifs par semaine",
    active_daily: "Actifs par jour",
    active_monthly: "Actifs par mois",
    active_six_months: "Actifs par semestre",
    enable_private_messages: "Activer les messages privés",
    auto_mark_fetched_posts_as_read: "Marquer automatiquement les publications récupérées comme lues",
    upload_and_publish_image_title: "Téléverser cette image ?",
    upload_and_publish_image_desc: "L'image téléversée sera diffusée vers les instances fédérées sans aucune intervention supplémentaire de la part de l'utilisateur.",
    vote_show: "Afficher",
    vote_show_for_others: "Afficher pour les autres",
    vote_hide: "Cacher",
    liked: "Aimé",
    none: "Aucun",
    back_to_first_page: "Première page",
    posts_per_page: "Publications par page",
    note_deleted: "Note supprimée",
    note_for_user: "Note pour l'utilisateur",
    create_user_note: "Créer une note utilisateur",
    new_account_label: "Nouveau compte, créé au cours des 7 derniers jours",
    last_updated: "Mise à jour le",
    notification_mode_all_posts_and_comments: "Toutes les publications et tous les commentaires",
    notification_mode_all_posts: "Toutes les publications",
    notification_mode_all_comments: "Tous les commentaires",
    notification_mode_replies_and_mentions: "Réponses et mentions (par défaut)",
    notification_mode_mute: "Silencieux",
    unknown_language: "Langue inconnue",
    registered_date_title: "Inscrit",
    ban_person_button: "Bannir {{name}}",
    banned_dialog_title_permanent: "Vous avez été banni définitivement",
    cant_view_private_community_message: "Vous n'êtes pas autorisé à consulter cette communauté. Cliquez sur le bouton « Suivre » et attendez que votre demande soit validée manuellement par un modérateur pour pouvoir accéder au contenu.",
    expand_all_images: "Afficher toutes les images",
    show_animated_images: "Afficher les images animées",
    hide_all_media: "Cacher tous les médias",
    couldnt_update: "Impossible de mettre à jour",
    couldnt_create: "Impossible de créer",
    cant_block_yourself: "Impossible de se bloquer soi-même",
    cant_block_admin: "Impossible de bloquer un administrateur",
    passwords_do_not_match: "Les mots de passe ne correspondent pas",
    pictrs_api_key_not_provided: "Clé API Pictrs manquante",
    invalid_image_upload: "Image invalide téléversée",
    image_upload_disabled: "Le téléversement d'images est désactivé",
    not_top_mod: "Vous n'êtes pas le modérateur principal",
    person_is_blocked: "La personne est bloquée",
    community_is_blocked: "La communauté est bloquée",
    instance_is_blocked: "L'instance est bloquée",
    registration_application_is_pending: "L'inscription est en attente de vérification par un administrateur",
    max_comment_depth_reached: "Limite maximale du nombre de niveaux de commentaires atteinte",
    already_exists: "L'élément existe déjà",
    nsfw_not_allowed: "Le contenu NSFW n'est pas autorisé sur cette instance",
    application_question_required: "Vous devez répondre à la question du formulaire d'adhésion",
    registration_username_required: "Un nom d'utilisateur est requis pour l'inscription",
    email_already_taken: "Cet email est déjà pris",
    username_already_taken: "Ce nom d'utilisateur est déjà pris",
    no_id_given: "Le nom ou l'identifiant doit être indiqué",
    local_site_not_setup: "Le site local n'est pas encore configuré",
    invalid_name: "Nom invalide",
    invalid_display_name: "Nom d'affichage invalide",
    invalid_body_field: "Le texte est trop long ou trop court",
    alt_text_length_overflow: "Le texte alternatif est trop long",
    couldnt_generate_totp: "Échec de la génération du code TOTP",
    missing_totp_token: "Jeton TOTP manquant",
    incorrect_totp_token: "Jeton TOTP incorrect",
    totp_already_enabled: "Le TOTP est déjà activé pour votre compte",
    blocked_url: "L'URL est bloquée sur cette instance",
    email_send_failed: "Échec de l'envoi de l'email",
    couldnt_create_image_captcha: "Échec de la création de l'image captcha",
    invalid_url_scheme: "Schéma d'URL non valide ; seuls les schémas http, https et magnet sont autorisés",
    invalid_bot_action: "Les robots ne sont pas autorisés à voter",
    cant_block_local_instance: "Impossible de bloquer l'instance locale",
    url_length_overflow: "L'URL est trop longue",
    not_found: "Introuvable",
    post_schedule_time_must_be_in_future: "L'heure de publication doit être dans le futur",
    couldnt_parse_pagination_token: "Jeton de pagination non valide",
    email_notifications_disabled: "Les notifications par email sont désactivées sur cette instance",
    too_many_requests: "Trop de requêtes",
    tags: "Étiquettes",
    summary: "Résumé",
    active_plugins: "Plugins actifs",
    community_not_federated_title: "La communauté n'est pas encore fédérée",
    dead_community_title: "Communauté inactive",
    dead_community_body: "Cette communauté n'est plus fédérée depuis plus d'une semaine. Il manquera probablement des publications et des commentaires récents. Il est probable que l'instance soit hors service ou qu'elle ait été défédérée.",
    store_link_previews: "Stocker les aperçus des liens",
    image_upload_timeout_seconds: "Délai d'attente pour le téléversement d'images (en secondes)",
    image_max_thumbnail_size: "Taille maximale des vignettes (en pixels)",
    image_max_avatar_size: "Taille maximale des avatars pour les utilisateurs et les communautés (en pixels)",
    image_max_banner_size: "Taille maximale des bannières pour les utilisateurs et les communautés (en pixels)",
    image_max_upload_size: "Taille maximale des images des publications/commentaires (en pixels)",
    image_allow_video_uploads: "Autoriser le téléversement de vidéos",
  },
} as const;